<footer role="contentinfo">
  <img src="/assets/images/logo.png" alt="Logo da RNN de Renan Fochetto">
</footer>
